import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TimeFormat } from "../../utils/TimeFormat";

const OfficeTimings = ({ officeHoursData = [], everydays }) => {
  const { t } = useTranslation();

  const getWeekDay = (hoursSequenceCheck, hoursData) =>
    hoursSequenceCheck && <> {everydays[hoursData?.dayOfWeek]}</>;

  const getFormattedData = useMemo(() => {
    const formattedData = {};
    officeHoursData.forEach((officeObj) => {
      const day = `weekDay${officeObj?.dayOfWeek}`;
      if (formattedData[day]) {
        const existingVal = formattedData[day];
        existingVal.push(officeObj);
        formattedData[day] = existingVal;
      } else {
        formattedData[day] = [officeObj];
      }
    });
    return formattedData;
  }, [officeHoursData]);

  const getTimings = (
    hoursSequenceCheck,
    hoursData,
    fromTimeCheck,
    toTimeCheck,
    toTimeCheckEquals
  ) => {
    const formattedTime =
      hoursData?.toTime !== "" && toTimeCheck
        ? TimeFormat(hoursData?.toTime)
        : "";
    return (
      hoursSequenceCheck && (
        <>
          {" "}
          &nbsp;&nbsp;{" "}
          {hoursData?.fromTime !== "" && fromTimeCheck
            ? TimeFormat(hoursData?.fromTime)
            : hoursData?.fromTime}{" "}
          {toTimeCheck ? "-" : <> &nbsp;|&nbsp; {hoursData?.toTime} </>}{" "}
          {toTimeCheckEquals ? "" : formattedTime}
        </>
      )
    );
  };

  const timings = (hoursDataArr) => {
    return hoursDataArr.map((hoursData) => {
      const hourDataCheck =
        hoursData?.fromTime !== null &&
        hoursData?.fromTime !== "" &&
        hoursData?.fromTime !== undefined &&
        hoursData?.toTime !== null &&
        hoursData?.toTime !== "" &&
        hoursData?.toTime !== undefined;

      const hoursSequenceCheck =
        hourDataCheck && hoursData?.sequenceNumber == "1";

      const toTimeCheck =
        hoursData?.toTime !== t("closed") &&
        hoursData?.toTime !== t("dayHours") &&
        hoursData?.toTime !== t("byAppt");

      const fromTimeCheck =
        hoursData?.fromTime !== t("closed") &&
        hoursData?.fromTime !== t("dayHours") &&
        hoursData?.fromTime !== t("byAppt");

      const toTimeCheckEquals =
        hoursData?.toTime === t("closed") &&
        hoursData?.toTime === t("dayHours") &&
        hoursData?.toTime === t("byAppt");

      const checkFromToTime =
        hoursData?.fromTime == t("closed") ||
        hoursData?.toTime == t("closed") ||
        hoursData?.fromTime == t("dayHours") ||
        hoursData?.toTime == t("dayHours") ||
        hoursData?.fromTime == t("byAppt") ||
        hoursData?.toTime == t("byAppt");
      return (
        <>
          {hoursSequenceCheck && (
            <span className="weekDay">
              {getWeekDay(hoursSequenceCheck, hoursData)}
            </span>
          )}
          <span>
            {getTimings(
              hoursSequenceCheck,
              hoursData,
              fromTimeCheck,
              toTimeCheck,
              toTimeCheckEquals
            )}
          </span>
          <span>
            {hourDataCheck &&
              everydays[hoursData?.dayOfWeek] !== t("sat") &&
              everydays[hoursData?.dayOfWeek] !== t("sun") &&
              hoursData?.sequenceNumber == "2" && (
                <>
                  {" "}
                  &nbsp; | &nbsp;
                  {fromTimeCheck ? TimeFormat(hoursData?.fromTime) : ""}{" "}
                  {toTimeCheck ? "-" : ""}{" "}
                  {toTimeCheck
                    ? TimeFormat(hoursData?.toTime)
                    : checkFromToTime && hoursData?.fromTime}
                </>
              )}
          </span>
        </>
      );
    });
  };

  const getOfficeTimings = (hoursData, indexVal) => {
    return (
      <div key={indexVal} className="timingWrapper">
        {timings(hoursData)}
      </div>
    );
  };

  return (
    Object.keys(getFormattedData)?.length > 0 &&
    Object.values(getFormattedData)?.map((hours, index) =>
      getOfficeTimings(hours, index)
    )
  );
};

export default OfficeTimings;
